(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mas-gift-banner"] && !Shopify.designMode) return;
  try {
    customElements.define('mas-gift-banner', class extends HTMLElement {
    connectedCallback() {
      try { this.hidden = sessionStorage.getItem('mas-gift-banner-dismissed-anua-80') === '1'; } catch {}
      this.querySelector('button').addEventListener('click', () => {
        this.hidden = true;
        try { sessionStorage.setItem('mas-gift-banner-dismissed-anua-80', '1'); } catch {}
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
